import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import PhotoEditingImageRepository from "~/repository/PhotoEditing/PhotoEditingImageRepository";

class PhotoEditingImageStore extends NestStore {
  rootStore = null;

  /**
   * @property {Object|null}
   */
  @observable photoEditingImage = null;

  /**
   * @property {number|null}
   */
  @observable photoEditingImageId = null;

  /**
   * @property {PhotoEditingImageRepository|null}
   */
  photoEditingImageRepository = null;

  constructor(rootStore) {
    super();

    this.rootStore = rootStore;

    this.photoEditingImageRepository = new PhotoEditingImageRepository();
  }

  @action
  import() {
    if (this.isLoading) {
      return Promise.resolve();
    }

    const { photoEditingJobStore } = this.rootStore;
    const { photoEditingJob } = photoEditingJobStore;

    const selectedPhotoEditingImages = photoEditingJob.photoEditingImages.filter(
      ({ isReady, isSelected }) => isReady && isSelected,
    );

    if (selectedPhotoEditingImages.length === 0) {
      return Promise.resolve();
    }

    // Get selected images ids
    const imagesIds = selectedPhotoEditingImages.map(({ photoEditingImageId }) => photoEditingImageId);

    this.isLoading = true;

    return this.photoEditingImageRepository.importToTour(photoEditingJob.tourId, imagesIds).finally(() => {
      this.isLoading = false;
    });
  }

  @action
  refund(photoEditingImageId) {
    this.isLoading = true;

    const { photoEditingJobStore } = this.rootStore;
    const { photoEditingJob } = photoEditingJobStore;

    return this.photoEditingImageRepository
      .refund(photoEditingImageId)
      .then(response => {
        const photoEditingImage = photoEditingJob.photoEditingImages.find(
          image => image.photoEditingImageId === photoEditingImageId,
        );

        photoEditingImage.refundDts = response.data.photoEditingImage.refundDts;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

export default PhotoEditingImageStore;
